import { render, staticRenderFns } from "./SocialContract.vue?vue&type=template&id=1af826cd&scoped=true"
import script from "./SocialContract.vue?vue&type=script&lang=js"
export * from "./SocialContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af826cd",
  null
  
)

export default component.exports